import React from 'react';
import { AppStore } from './../Core/AppStore';
import { Storage } from './../Core/Storage';
import { Routes } from './../Core/Constants';

export default class CheckoutHeader extends React.Component {
	constructor(props) {

		super(props);
		this.state = {
			show: props.show
		};
		AppStore.on("Checkout.Header", (show) => {
			if (this.state.show != show) {
				
				if (show) {
					window.document.querySelector('#header > .top-nav').style.display = 'none';
					window.document.querySelector('#header > #navbar-default').style.display = 'none';
					window.document.querySelector('#header > #navbar-checkout').style.display = 'flex';
				}
				else {
					window.document.querySelector('#header > .top-nav').style.display = 'flex';
					window.document.querySelector('#header > #navbar-checkout').style.display = 'none';
					window.document.querySelector('#header > #navbar-default').style.display = 'flex';

				}
				this.setState({ show: show });
			}

		});
	}
	//switch (Config.mode)
	render = () => {
		if (!this.state.show)
			return null;
		var T = window.Texts.checkout;
		return (
			
				<div className="xo-header">
					<div className="box logo" data-_gtm_ga_navigation="header.logo">
					<a href="/">
						{(Config.mode == 'liveest') ? <img src={Routes.Home + 'Content/img/eurostyle.svg'} alt={T.ShopName} /> : (Config.mode == 'liveua') ?<img src={Routes.Home + 'Content/img/skandy.gif'} alt={T.ShopName} /> : <img src={Routes.Home + 'Content/img/idea-nabytek.svg'} alt={T.ShopName} />}
						</a>
					</div>
					<div className="xo-claim">
						{T.headertext}
					</div>
					<div className="xo-contact">
					<div className="xo-contact-pic" >
						<span className="xo-contact-phone">{T.contactHours}</span>
					</div>
					</div>
			</div>);
	}
}

if (Storage.instance().isSegmentUser())
{
	var element = document.getElementById("navbar-checkout");
	ReactDOM.render(<CheckoutHeader show={false} />, element);
}
